module.exports = __webpack_public_path__ + "files/f727c25e39b2c6ab242edba88bc6f703.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-1.png
// module id = 1490
// module chunks = 60